import Radium from "radium";
import React from "react";

import { listStyles } from "@common/styles";
import { IDevice } from "@common/models";
import DeviceRow from "./device-row";
import { Remo } from "@components";

import EditDevice from "./edit-device";
import ApproveDevice from "./approve-device";

export interface IDeviceListProps {
  devices: IDevice[];
  userId: string;
}

export interface IDeviceListActions {
  approveDevice: (userId: string, deviceId: string) => void;
  removeDevice: (userId: string, deviceId: string) => void;
}

export interface IDeviceListState {
  deviceToRemove: IDevice;
  deviceToApprove: IDevice;
}

class DeviceList extends React.Component<
  IDeviceListProps & IDeviceListActions,
  IDeviceListState
> {
  public render() {
    const rowStyle = { ...listStyles.row, alignItems: "left" };
    const listItemStyle = { ...listStyles.listItem, fontSize: "13px" };
    const wideItemStyle = { ...listItemStyle, width: "100%", flex: "3" };
    const editLinkStyle = {
      ...listItemStyle,
      justifyContent: "flex-end",
      width: "20%",
      flex: "1"
    };

    const { devices, approveDevice, removeDevice, userId } = this.props;
    const userHasDevices = devices && devices.length > 0;

    return (
      <div>
        <div style={listStyles.rowHeader as any} className="rowHeader">
          <div style={listItemStyle as any}>Enheter</div>
        </div>
        <div style={rowStyle as any} className="row">
          <div style={userHasDevices ? wideItemStyle : (listItemStyle as any)}>
            <div style={listStyles.subItem as any}>
              {userHasDevices ? (
                devices.map((device, index) => (
                  <DeviceRow
                    key={index}
                    device={device}
                    approveDevice={deviceToApprove =>
                      this.setState({ deviceToApprove })
                    }
                    removeDevice={deviceToRemove =>
                      this.setState({ deviceToRemove })
                    }
                  />
                ))
              ) : (
                <div>Ingen enheter</div>
              )}
            </div>
          </div>
          <div style={userHasDevices ? { display: "none" } : editLinkStyle} />
        </div>
        <Remo show={!!this.state.deviceToRemove}>
          <EditDevice
            device={this.state.deviceToRemove}
            removeDevice={this.removeDevice}
            closeModal={() => this.setState({ deviceToRemove: null })}
          />
        </Remo>
        <Remo show={!!this.state.deviceToApprove}>
          <ApproveDevice
            device={this.state.deviceToApprove}
            approveDevice={this.approveDevice}
            closeModal={() => this.setState({ deviceToApprove: null })}
          />
        </Remo>
      </div>
    );
  }

  private removeDevice = () => {
    const { userId } = this.props;
    const { deviceToRemove } = this.state;
    this.setState({ deviceToRemove: null }, () =>
      this.props.removeDevice(userId, deviceToRemove.deviceId)
    );
  };

  private approveDevice = () => {
    const { userId } = this.props;
    const { deviceToApprove } = this.state;
    this.setState({ deviceToApprove: null }, () =>
      this.props.approveDevice(userId, deviceToApprove.deviceId)
    );
  };
}

export default Radium(DeviceList);
